import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';
import Reveal from './Reveal';

const Testimonials = () => {
  return (
    <section id="reviews" className="py-24 relative">
      <div className="container-ydd">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-[var(--ydd-yellow)] font-semibold text-sm uppercase tracking-widest">User Feedback</span>
            <h2 className="font-display text-white text-3xl md:text-5xl mt-4 leading-tight">Loved by readers</h2>
            <p className="text-gray-400 mt-4 text-lg">Join thousands who stay informed and save money every single day.</p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 mt-14">
          {testimonials.map((t, i) => (
            <Reveal key={t.name} delay={i * 120}>
              <div className="card-ydd p-7 h-full flex flex-col">
                <Quote size={30} className="text-[var(--ydd-yellow)]/40" />
                <p className="text-gray-200 mt-4 leading-relaxed flex-1">“{t.quote}”</p>
                <div className="flex items-center gap-1 mt-5">
                  {Array.from({ length: t.rating }).map((_, k) => (
                    <Star key={k} size={15} className="text-[var(--ydd-yellow)] fill-[var(--ydd-yellow)]" />
                  ))}
                </div>
                <div className="flex items-center gap-3 mt-5 pt-5 border-t border-white/8">
                  <img src={t.avatar} alt={t.name} className="h-11 w-11 rounded-full object-cover border border-white/10" />
                  <div>
                    <div className="text-white font-semibold text-sm">{t.name}</div>
                    <div className="text-gray-500 text-xs">{t.role}</div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
